import { alpha, Box, styled } from '@shared/components';
import type { PropsWithChildren } from '@shared/utils';

export interface RichTextEditorBoxWrapperProps extends PropsWithChildren {
  error?: boolean;
}

const StyledBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'error',
})<RichTextEditorBoxWrapperProps>(({ error, theme }) => ({
  border: `1px solid ${theme.palette.grey['300']}`,
  position: 'relative',
  borderRadius: theme.shape.rounded(2),
  borderColor: error ? theme.palette.error.main : theme.palette.grey['300'],
  boxShadow: error ? `0 0 0 3px ${alpha(theme.palette.error.main, 0.25)}` : 'none',
  '&:focus-within': {
    borderColor: theme.palette.primary.main,
    boxShadow: `0 0 0 3px ${alpha(theme.palette.primary.main, 0.25)}`,
  },
}));

// NOTE: By this approach, we cannot override external styling.
// If we were to override this component, we can simply add sx props
// and pass it to this component.
export default function RichTextEditorBoxWrapper(props: Readonly<RichTextEditorBoxWrapperProps>) {
  const { children, error: isError } = props;

  return <StyledBox error={isError}>{children}</StyledBox>;
}
